
import { Vue, Component, Prop } from "vue-property-decorator";

import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import UiButton from "@/components/button/ui-button.vue";
import UPDATE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from "@/apollo/projectActivities/ProjectActivityRequestMoreHours.gql";
import {Project_Activity_Request_More_Hours } from "@/generated/graphql";

@Component({
    components: {
        ModalContent,
        UiButton,
        ModalFullScreen,
    },
})
export default class RequestMoreHoursDeclineReasonModal extends Vue {
    @Prop({ type: Object, required: true }) readonly time!: Project_Activity_Request_More_Hours;
    processing: boolean = false;
    declineDisabled: boolean = false;
    decline_reason: string = "";
    id: string = "";

   async declineRequest(): Promise<void> {
        this.processing = true;
        this.declineDisabled = true;

        let id = this.time.id;
        let obj = {
            status: "DECLINED",
            decline_reason: this.decline_reason
        }

        await this.$apollo.mutate({
            mutation: UPDATE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
            variables: {
                id: id,
                obj: obj
            }
        });

        this.processing = false;
        this.declineDisabled = false;
        this.decline_reason = ""

        this.$emit("closeRequestMoreHoursDeclineModal");
    
    }

    get canSave(): boolean {
        if (this.processing || this.decline_reason === "") {
            return false;
        }
        return true;
    }
}
